import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {AbstractControl} from '@angular/forms';
import {HttpHandlingService} from '../../../../../api/services/http-handling.service';
import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SERVER_API_URL} from '../../../../types/app.constants';
import { ApiDataService } from 'src/app/api/services/api-data.service';
import { Competition } from '../models/competition.interface';
import { SelectedItem } from 'src/app/controls/models/selected-item.interface';
import { CompetitionData } from '../models/competition-data.interface';

@Injectable()
export class CompetitionCardService {

  private service = inject(ApiDataService);

  /**
   * Creates new competition
   * @param data the competition data
   */
  create(data: CompetitionData): Observable<number> {
    return this.service.post<number>('competitions/create', data);
  }

  /**
   * Updates the existing competition
   * @param data the competition data
   */
  update(data: CompetitionData): Observable<boolean> {
    return this.service.put<boolean>('competitions/update', data);
  }

  /**
   * Gets desired competition by id
   * @param competitionId for evaluation of desired competition
   */
  getCompetition(competitionId: number): Observable<Competition> {
    return this.service.get<Competition>('competitions/get/' + competitionId);
  }

  /**
   * Gets the list of competitors for author picking
   * @returns list list of competitors
   */
  getCompetitors(): Observable<SelectedItem[]> {
    return this.service.getAll<SelectedItem>('competitors/get-for-dropdown');
  }

  delete(id: number): Observable<boolean> {
    return this.service.delete<boolean>('competition/delete', id);
  }

  /**
     * Gets the display results status of the desired competition
     * @param id the id of the desired competition
     * @returns display results status
     */
  public getDisplayResultsStatus(id: number): Observable<boolean> {
    return this.service.get<boolean>('competitions/get-results-status/' + id);
  }

  /**
   * Updates the display results status of the desired competition
   * @param id the id of the desired competition
   */
  public updateResultsStatus(id: number): Observable<void> {
    return this.service.patchEmpty<void>('competitions/update-results-status/' + id);
  }

  /**
   * Recalculates the whole competition results
   * @param id the competition id reference
   */
  public recalculateResults(id: number): Observable<boolean> {
    return this.service.patchEmpty<boolean>('competitions/recalculate/' + id);
  }
}
